import { DemoIds, IDemo } from 'types'

import { getSharedAsset } from '../utils'

const video = getSharedAsset('vuzix.mp4', 'sessions', 'videos')
const poster = getSharedAsset('vuzix.png', 'sessions', 'posters')
const monolith = getSharedAsset('vuzix.png', 'sessions', 'monoliths')
const nextDemoThumbnail = getSharedAsset('taqtile.png', 'sessions', 'thumbnails')

export const vuzix: IDemo = {
  id: DemoIds.vuzix,
  video,
  monolith,
  poster,
  end: {
    header: 'Augmented reality workforce solutions.',
    body: `Verizon’s 5G Ultra Wideband network and Vuzix M400 Smart Glasses have the potential to deliver on the job expertise and knowledge transfer remotely to keep workers safe and increase productivity.`,
    nextDemoText: 'Immersive 5G AR/VR training.',
    nextDemoId: DemoIds.taqtile,
    nextDemoThumbnail,
    previousDemoId: DemoIds.jigspace
  }
}
